// client/src/neetjee_guru/components/libraryManagement/LibrarySettings.jsx
import React, { Component } from "react";
import { Form, Button, Row, Col, Alert, Spinner, Card } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { GET_LIBRARY_SETTINGS } from "./queries";
import { UPDATE_LIBRARY_SETTINGS } from "./mutations";

class LibrarySettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      library_name: "",
      timings: "",
      fine_per_day: 0.0,
      max_borrow_days: 14,
      max_books: 3,
      max_renewals: 2,
      semester_borrow_days: 120,
      max_semester_books: 4,
      
      loading: true,
      saving: false,
      successMessage: null,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.fetchSettings();
  }

  fetchSettings = async () => {
    const { client } = this.props;
    const instId = parseInt(Cookies.get("institutionid") || Cookies.get("institute_id") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || "0");

    try {
      this.setState({ loading: true });
      const { data } = await client.query({
        query: GET_LIBRARY_SETTINGS,
        variables: { institute_id: instId, branch_id: branchId },
        fetchPolicy: "network-only",
      });

      const s = data.getLibrarySettings;
      if (s) {
        this.setState({
          library_name: s.library_name,
          timings: s.timings,
          fine_per_day: s.fine_per_day,
          max_borrow_days: s.max_borrow_days,
          max_books: s.max_books,
          max_renewals: s.max_renewals,
          semester_borrow_days: s.semester_borrow_days || 120,
          max_semester_books: s.max_semester_books || 4,
        });
      }
      this.setState({ loading: false, errorMessage: null });
    } catch (err) {
      console.error("Error fetching library settings:", err);
      this.setState({ errorMessage: err.message, loading: false });
    }
  };

  handleFieldChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleNumberChange = (e) => {
    this.setState({ [e.target.name]: parseFloat(e.target.value) || 0 });
  };

  handleIntChange = (e) => {
    this.setState({ [e.target.name]: parseInt(e.target.value) || 0 });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { client } = this.props;
    const { library_name, timings, fine_per_day, max_borrow_days, max_books, max_renewals, semester_borrow_days, max_semester_books } = this.state;
    const instId = parseInt(Cookies.get("institutionid") || Cookies.get("institute_id") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || "0");

    try {
      this.setState({ saving: true, successMessage: null, errorMessage: null });
      await client.mutate({
        mutation: UPDATE_LIBRARY_SETTINGS,
        variables: {
          input: {
            library_name,
            timings,
            fine_per_day,
            max_borrow_days,
            max_books,
            max_renewals,
            semester_borrow_days: parseInt(semester_borrow_days) || 120,
            max_semester_books: parseInt(max_semester_books) || 4,
            institute_id: instId,
            branch_id: branchId,
          },
        },
      });
      this.setState({ saving: false, successMessage: "Library settings updated successfully!" });
      if (this.props.showToast) {
        this.props.showToast("Library settings saved successfully!", "success");
      }
    } catch (err) {
      console.error("Error updating settings:", err);
      this.setState({ saving: false, errorMessage: err.message });
    }
  };

  render() {
    const {
      library_name,
      timings,
      fine_per_day,
      max_borrow_days,
      max_books,
      max_renewals,
      semester_borrow_days,
      max_semester_books,
      loading,
      saving,
      successMessage,
      errorMessage,
    } = this.state;

    if (loading) {
      return <div className="shimmer" style={{ height: 350, borderRadius: 12 }} />;
    }

    return (
      <div style={{ width: "100%" }}>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 style={{ fontWeight: 800, color: "#0f172a", margin: 0 }}>Library Settings</h4>
            <p className="text-muted" style={{ fontSize: 13, margin: "4px 0 0 0" }}>Configure circulation rules, checkout limits, and general catalog preferences.</p>
          </div>
        </div>

        {successMessage && (
          <Alert variant="success" className="mb-4 d-flex align-items-center" style={{ borderRadius: 8 }}>
            <i className="fal fa-check-circle mr-2" style={{ marginRight: 8, fontSize: 16 }} />
            {successMessage}
          </Alert>
        )}
        {errorMessage && (
          <Alert variant="danger" className="mb-4 d-flex align-items-center" style={{ borderRadius: 8 }}>
            <i className="fal fa-exclamation-circle mr-2" style={{ marginRight: 8, fontSize: 16 }} />
            {errorMessage}
          </Alert>
        )}

        <Form onSubmit={this.handleSubmit}>
          <Row>
            <Col lg={6} md={12}>
              <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: 12, overflow: "hidden" }}>
                <Card.Header style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", padding: "18px 24px" }}>
                  <div className="d-flex align-items-center">
                    <i className="fal fa-university text-primary" style={{ fontSize: 16, marginRight: 10 }} />
                    <h6 className="mb-0" style={{ fontWeight: 800, color: "#1e293b" }}>Library Profile & Academic Policies</h6>
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: "24px" }}>
                  <div style={{ marginBottom: "20px" }}>
                    <div className="d-flex align-items-center mb-3">
                      <div style={{ width: 4, height: 16, background: "#6366f1", borderRadius: 2, marginRight: 8 }}></div>
                      <span style={{ fontSize: 13, fontWeight: 800, color: "#334155" }}>General Profile</span>
                    </div>

                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Library Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="library_name"
                        value={library_name}
                        onChange={this.handleFieldChange}
                        required
                        placeholder="e.g. Central Engineering Library"
                        style={{ height: 42, fontSize: 13 }}
                      />
                      <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                        Official name of the institute library shown on receipts and reports.
                      </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-0">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Timings / Working Hours *</Form.Label>
                      <Form.Control
                        type="text"
                        name="timings"
                        value={timings}
                        onChange={this.handleFieldChange}
                        required
                        placeholder="e.g. 9:00 AM - 6:00 PM"
                        style={{ height: 42, fontSize: 13 }}
                      />
                      <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                        Operating hours displayed to students on the member dashboard.
                      </Form.Text>
                    </Form.Group>
                  </div>

                  <hr style={{ borderTop: "1px dashed #e2e8f0", margin: "24px 0" }} />

                  <div>
                    <div className="d-flex align-items-center mb-3">
                      <div style={{ width: 4, height: 16, background: "#6366f1", borderRadius: 2, marginRight: 8 }}></div>
                      <span style={{ fontSize: 13, fontWeight: 800, color: "#334155" }}>Semester Book Bank Rules</span>
                    </div>

                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Semester Borrow Duration (Days) *</Form.Label>
                      <Form.Control
                        type="number"
                        min="1"
                        name="semester_borrow_days"
                        value={semester_borrow_days}
                        onChange={this.handleIntChange}
                        required
                        style={{ height: 42, fontSize: 13 }}
                      />
                      <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                        Circulation period in days for semester-long book checkouts.
                      </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-0">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Max Semester Books (Book Bank) *</Form.Label>
                      <Form.Control
                        type="number"
                        min="1"
                        name="max_semester_books"
                        value={max_semester_books}
                        onChange={this.handleIntChange}
                        required
                        style={{ height: 42, fontSize: 13 }}
                      />
                      <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                        Active checkout quota allowed for semester Book Bank items per student.
                      </Form.Text>
                    </Form.Group>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6} md={12}>
              <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: 12, overflow: "hidden", height: "calc(100% - 24px)" }}>
                <Card.Header style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", padding: "18px 24px" }}>
                  <div className="d-flex align-items-center">
                    <i className="fal fa-calendar-edit text-primary" style={{ fontSize: 16, marginRight: 10 }} />
                    <h6 className="mb-0" style={{ fontWeight: 800, color: "#1e293b" }}>Standard Borrowing Rules</h6>
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: "24px", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "calc(100% - 60px)" }}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Fine Amount per Overdue Day (₹) *</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.1"
                      min="0"
                      name="fine_per_day"
                      value={fine_per_day}
                      onChange={this.handleNumberChange}
                      required
                      style={{ height: 42, fontSize: 13 }}
                    />
                    <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                      Daily penalty charged in INR for overdue standard items.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Max Borrow Duration (Days) *</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      name="max_borrow_days"
                      value={max_borrow_days}
                      onChange={this.handleIntChange}
                      required
                      style={{ height: 42, fontSize: 13 }}
                    />
                    <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                      Default circulation period in days for standard book checkouts.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Max Books per Student *</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      name="max_books"
                      value={max_books}
                      onChange={this.handleIntChange}
                      required
                      style={{ height: 42, fontSize: 13 }}
                    />
                    <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                      Active checkout quota allowed for standard books per student.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-0">
                    <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>Max Renewals Allowed *</Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      name="max_renewals"
                      value={max_renewals}
                      onChange={this.handleIntChange}
                      required
                      style={{ height: 42, fontSize: 13 }}
                    />
                    <Form.Text className="text-muted" style={{ fontSize: 10.5, marginTop: 4, display: "block" }}>
                      Number of times a student can extend a loan before returning the item.
                    </Form.Text>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <div className="text-right mt-3 pb-4">
            <Button
              type="submit"
              disabled={saving}
              style={{
                background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                border: "none",
                fontWeight: 700,
                fontSize: 13,
                padding: "10px 32px",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(99, 102, 241, 0.2)"
              }}
            >
              {saving ? <Spinner animation="border" size="sm" /> : "Save Changes"}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default LibrarySettings;
